import {BANG, NFT} from 'messaging/message-types.js';
import {doc} from './docs.js';
import ZNFT from "nft/ZNFT.js";
import {value} from 'nft/random.js';

// an object that calls
doc(
    "nft",
    {
    },
    "Random number generator based on NFT\'s token seed",
    (x) => 0
);
export const nft = (object ) => {
    let znft = new ZNFT(object);
    object.effect = znft;
    object.needsNFT = true;

    return ([type]) => {
        switch (type) {
        case NFT:
            znft.startUp();
            break;
        default:
            znft.execute();
            break;
        }
    };
};

// an object that calls
doc(
    "erc720.tokenID",
    {
    },
    "Returns the tokenID URL param of this page (for ERC720 tokens)",
    (x) => 1
);
export const erc720_tokenID = (object ) => {
    object.needsLoad = true;

    return ([msg]) => {
        return [object.sequencerEngine.tokenID];
    };
};

